const rankings = [
  { rank: 1, title: '星际迷途：新纪元', tag: '科幻', hot: '本周热度 98.6', change: 'up' },
  { rank: 2, title: '暗夜追踪', tag: '悬疑', hot: '本周热度 95.2', change: 'up' },
  { rank: 3, title: '笑傲江湖之风云再起', tag: '喜剧', hot: '本周热度 91.8', change: 'new' },
  { rank: 4, title: '热血拳台', tag: '运动', hot: '本周热度 88.4', change: 'up' },
  { rank: 5, title: '花样年华·续', tag: '文艺', hot: '本周热度 85.1', change: 'down' },
  { rank: 6, title: '极地奇迹', tag: '动画', hot: '本周热度 81.7', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            热门榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            实时追踪全网影迷观影热度，发现大家都在看的好电影
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 md:px-6 md:py-5 cursor-pointer transition-colors hover:bg-primary-50/30 ${
                i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div
                className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading text-base font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-white'
                    : item.rank === 2
                      ? 'bg-accent-300 text-accent-900'
                      : item.rank === 3
                        ? 'bg-secondary-300 text-secondary-900'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-foreground-900 truncate">
                  {item.title}
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-foreground-400">{item.tag}</span>
                </div>
              </div>
              <div className="flex items-center gap-2 text-right flex-shrink-0">
                <span className="text-xs text-foreground-500 hidden sm:inline">{item.hot}</span>
                <span
                  className={`text-xs font-medium whitespace-nowrap ${
                    item.change === 'up'
                      ? 'text-primary-600'
                      : item.change === 'new'
                        ? 'text-accent-600'
                        : 'text-foreground-400'
                  }`}
                >
                  {item.change === 'up' ? '↑' : item.change === 'new' ? 'NEW' : '↓'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}